import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, isRef as _isRef, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("新增水电费")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("选择")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("编 辑")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { style: {"fontSize":"22px"} }, "请备注清楚费用的归属部门或公司、归属月份，以及发票类型", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("选择文件")

  
const __default__ = {
  name: 'leaseDeatils'
}
import {computed, ref} from 'vue'
import { useRoute } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import { formatNumber } from '@/utils/index'
import tbMix from '@/global_mixin/tableMixin'
import PaymentModuleUtils from "@/views/typeMapping/PaymentModuleUtils"
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    leaseId: null
  },
  emits: ['billFill'],
  setup(__props: any, { emit }) {

const props = __props as {
  leaseId?: number
}

const {
  'POST/house_lease_bill_details/list': fetchList,
  // 获取所有公司
  'GET/company': companyApi,
  // 创建水电费
  'POST/house_lease_bill_details/utilities': createdUtilitiesApi,
  // 生成账单获取建议值
  'POST/house_lease_bill_details/info': house_lease_bill_detailsInfoApi,
  // 创建账单并移入支付池
  'POST/house_lease_bill_details/bill': createBillApi,
  // 编辑
  'PATCH/house_lease_bill_details': editBillApi,
  // 上传支付凭证文件
  'POST/lease_payment_logs/upload': upFileApi,
  // 删除
  'DELETE/house_lease_bill_details/{id}': delApi,
} = Api



const route = useRoute()
let {currencyOption} = PaymentModuleUtils

const {
  MI_tableData, fetchData, page, size,
  MI_total, MI_pageChange, MI_sizeChange,
  MI_identify, MI_params, MI_modifyForm, MI_height,
} = new tbMix(fetchList);
size.value = 1000
fetchData({leaseId: route.params.id || props.leaseId})

const sortTbData = computed(() => {
  // 未生成账单
  let beforeCreate: object[] = []
  // 获取已经生成账单数据： billId > 0
  let _createdBill = MI_tableData.value.reduce((arr: object[], item: any) =>{
    if(item.billId !== 0){
      // 展开
      arr.push(item)
    } else {
      beforeCreate.push(item)
    }
    return arr
  }, [])

  return [{ id: 'unCreatedBill', feeType: 'unCreatedBill', children: beforeCreate}, { id: 'createdBill', feeType: 'createdBill', children: _createdBill }]
})

const detailRows = ref<{id: string} []>([])
const handleSelectionChange = (val: any[]) => {
  detailRows.value = val
}
const selectedHandle = (row: any, index: number) => {
  if(row.id === 'unCreatedBill' || row.id === 'createdBill'){
    return false
  }
  if(row.billId !== 0){
    return false
  }
  if(row.valid === true){
    return true
  } else if(row.remainDay < 0 && row.valid === false){
    return false
  } else if(row.remainDay > 0 && row.valid === false) {
    return true
  }

  return true
}
// ---------------

const addFg = ref<boolean>(false)
const addUtilitiesConfig = ref([
  {
    type: "TIME",
    label: "开始日期",
    value: '',
    upKey: 'startDate',
    rule: [
      { required: true, message: '开始日期不能为空', trigger: 'change' },
    ],
    props: {
      'value-format': 'YYYY-MM-DD',
      clearable: true
    }
  },
  {
    type: "TIME",
    label: "结束日期",
    value: '',
    upKey: 'endDate',
    rule: [
      { required: true, message: '结束日期不能为空', trigger: 'change' },
    ],
    props: {
      'value-format': 'YYYY-MM-DD',
      clearable: true
    }
  },
  {
    type: 'NUMBER',
    label: '水电费',
    value: '',
    upKey: 'utilities',
    rule: [
      { required: true, message: '水电费不能为空', trigger: 'change' },
      { type: 'number', message: '请输入数字' },
    ],
    props: {clearable: false, type: 'number',}
  },
  {
    type: 'NUMBER',
    label: '其他费用',
    value: '',
    upKey: 'otherFee',
    rule: [
      { required: true, message: '其他费用不能为空', trigger: 'change' },
      { type: 'number', message: '请输入数字' },
    ],
    props: {clearable: false, type: 'number',}
  },
])
const addHandle = () => {
  MI_modifyForm({otherFee: 0, utilities: 0}, addUtilitiesConfig, addFg, async (params: any) => {
    await createdUtilitiesApi({...params, leaseId: route.params.id})
    ElMessage.success('创建成功')
    addFg.value = false
    fetchData(MI_params)
  })
}

// 生成账单
const generateBillEle = ref()
const addBillFg = ref<boolean>(false)
const upFileFg = ref(false)

const addBillConfig = ref([
  {
    type: "TIME",
    label: "开始时间",
    value: '',
    upKey: 'startDate',
    props: {
      'value-format': 'YYYY-MM-DD',
      clearable: true,
      disabled: false,
    }
  },
  {
    type: "TIME",
    label: "结束日期",
    value: '',
    upKey: 'endDate',
    rule: [
      { required: true, message: '结束日期不能为空', trigger: 'change' },
    ],
    props: {
      'value-format': 'YYYY-MM-DD',
      disabled: false,
      clearable: true
    }
  },
  {
    type: 'NUMBER',
    label: '租金',
    value: '',
    upKey: 'rentFee',
    rule: [
      { type: 'number', message: '请输入数字' },
    ],
    props: {disabled: true, type: 'number',}
  },
  {
    type: 'NUMBER',
    label: '月物管费',
    value: '',
    upKey: 'pmFee',
    rule: [
      { type: 'number', message: '请输入数字' },
    ],
    props: {disabled: true, type: 'number',}
  },
  {
    type: 'NUMBER',
    label: '水电费',
    value: '',
    upKey: 'utilities',
    rule: [
      { type: 'number', message: '请输入数字' },
    ],
    props: { disabled: true, type: 'number' }
  },
  {
    type: 'NUMBER',
    label: '其他费用',
    value: '',
    upKey: 'otherFee',
    rule: [
      { type: 'number', message: '请输入数字' },
    ],
    props: { disabled: true, type: 'number' }
  },
  {
    type: 'NUMBER',
    label: '押金',
    value: '',
    upKey: 'depositFee',
    rule: [
      { type: 'number', message: '请输入数字' },
    ],
    props: { disabled: true, type: 'number' }
  },
  {
    type: 'SELECT',
    label: '公司',
    value: '',
    upKey: 'company',
    options: [],
    placeholder: '请选择公司',
    selectFunc: companyApi,
    seleProps: {
      label: 'name',
      valueName: 'name',
    },
    props: { placeholder: '请选择公司', clearable: true, disabled: true }
  },
  {
    label: '收款人',
    value: '',
    upKey: 'receiverName',
    rule: [
      { required: true, message: '收款人不能为空', trigger: 'change' },
    ],
  },
  {
    label: '银行名称',
    value: '',
    upKey: 'bankName',
    rule: [
      { required: true, message: '银行名称不能为空', trigger: 'change' },
    ],
  },
  {
    label: '账号',
    value: '',
    upKey: 'account',
    rule: [
      { required: true, message: '账号不能为空', trigger: 'change' },
    ],
  },
  {
    type: 'SELECT',
    label: '币种',
    value: '',
    upKey: 'currency',
    options: currencyOption(),
    props: {clearable: true, placeholder: '请选择租房类型',},
    seleProps: {
      label: 'label',
      valueName: 'id',
    },
    rule: [
      { required: true, message: '币种不能为空', trigger: 'change' },
    ],
  },
  {
    label: '备注',
    value: '',
    upKey: 'remark',
    props: {type: 'textarea', rows: 2, style: 'width: 500px'},
    rule: [{ required: true, message: '备注不能为空', trigger: 'change' }],
  },
  /* {
    type: 'NUMBER',
    label: '金额',
    value: '',
    upKey: 'amount',
  }, */
])
let generateBillId: number 
const showAddBill = async () => {
  if(detailRows.value.find((e: any) => e.valid === false) !== undefined){
    await ElMessageBox.alert(
      '已选择的明细存在已过期',
      '请注意',
      {
        confirmButtonText: '确定',
        type: 'warning',
      }
    )
  }
  let recommendedVal = {}
  try {
    MI_identify.value = true
    recommendedVal = await house_lease_bill_detailsInfoApi({
      ids: detailRows.value.map((e: any) => e.id),
      leaseId: route.params.id,
      company: route.params.lessee,
    })
    MI_identify.value = false
  } catch (error) {
    MI_identify.value = false
  }
  MI_modifyForm(recommendedVal, addBillConfig, addBillFg, async (parasm: any) => {
    let rep = await createBillApi({
      leaseId: route.params.id,
      ids: detailRows.value.map((e: any) => e.id),
      ...parasm,
    })
    generateBillId = rep.billId
    ElMessage.success('生成账单成功')
    addBillFg.value = false
    fetchData(MI_params)

    // 账单付款凭证上传
    upFileConfig.value[0].value = parasm.rentFee + parasm.pmFee + parasm.utilities + parasm.otherFee + parasm.depositFee
    upFileFg.value = true
  })
}

let fileList: any = []
let onChange = (file: any, files: any) => {
  fileList = files
}

const upFileConfig: any = ref([
  {
    type: 'NUMBER',
    label: '金额',
    value: undefined,
    upKey: 'amount',
    rule: [{ required: true, message: '金额不能为空', trigger: 'change' }],
    props: { clearable: true }
  },
])
const generateBillHandle = async (params: {amount: string}) => {
  if(fileList.length <= 0){
    ElMessage.warning({message: '请选择文件', grouping: true })
    return
  }
  const form: any = new FormData();
  form.append("contractId", route.params.contractId)
  form.append("leaseId", route.params.id)
  form.append("billId", generateBillId)
  form.append("amount", params.amount)


  fileList.map((_file: any) => {
    form.append("file", _file.raw);
  })

  await upFileApi(form)
  ElMessage.success('上传成功')
  upFileFg.value = false
}

// 编辑
const editFg = ref<boolean>(false)
// Deposit || Rent || PM
let editType = ref('')
const editPm =computed(() => editType.value !== 'PM')
const editRent = computed(() => editType.value !== 'Rent')
const editDeposit =computed(() => editType.value !== 'Deposit')
const editUtilities =computed(() => editType.value !== 'Utilities')
const editConfig = ref([
  {
    type: 'NUMBER',
    label: '租金',
    value: '',
    upKey: 'rentFee',
    rule: [
      { type: 'number', message: '请输入数字' },
    ],
    props: { disabled: editRent, type: 'number', },
  },
  {
    type: 'NUMBER',
    label: '月物管费',
    value: '',
    upKey: 'pmFee',
    rule: [
      { type: 'number', message: '请输入数字' },
    ],
    props: { disabled: editPm, type: 'number', },
  },
  {
    type: 'NUMBER',
    label: '水电费',
    value: '',
    upKey: 'utilities',
    rule: [
      { type: 'number', message: '请输入数字' },
    ],
    props: { disabled: editUtilities, type: 'number', }
  },
  {
    type: 'NUMBER',
    label: '其他费用',
    value: '',
    upKey: 'otherFee',
    rule: [
      { type: 'number', message: '请输入数字' },
    ],
    props: { disabled: editUtilities, type: 'number', }
  },
  {
    type: 'NUMBER',
    label: '押金',
    value: '',
    upKey: 'depositFee',
    rule: [
      { type: 'number', message: '请输入数字' },
    ],
    props: { disabled: editDeposit, type: 'number', },
  },
])
const editHandle = (row: any) => {
  editType.value = row.feeType

  MI_modifyForm(row, editConfig, editFg, async (parasm: any) => {
    
    await editBillApi({...parasm, id: row.id})
    ElMessage.success('编辑成功')
    fetchData(MI_params)
    editFg.value = false
  })
}

// 删除 
const delHandle = () =>{
  if(detailRows.value.length !== 1){
    ElMessage.warning('请只选择一条数据')
    return
  }

  ElMessageBox.confirm(
    '确定删除？',
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(() => {
      MI_identify.value = true
      return delApi({id: detailRows.value[0].id})
    })
    .then(() =>{
      ElMessage.success('删除成功')
      MI_identify.value = false
      fetchData(MI_params)
    })
    .catch(() => {
      MI_identify.value = false
    })
}

// 选择生成
const generateHandle = async () => {
  if(detailRows.value.find((e: any) => e.valid === false) !== undefined){
    await ElMessageBox.alert('已选择的明细存在已过期', '请注意', { type: 'warning'})
  }
  emit('billFill', detailRows.value)
}

// ----------------格式化列内容-------------------

const formatFeeType = (row: object, column: any, cellValue: string, index: number) =>{
  switch (cellValue) {
    case 'Rent':
      return '房租'
      break;
    case 'Utilities':
      return '水电费及其他'
      break;
    case 'PM':
      return '物管费'
      break;
    case 'createdBill':
      return '已生成账单'
      break;
    case 'unCreatedBill':
      return '未生成账单'
      break;
    case 'Deposit':
      return '押金'
      break;
  
    default:
      break;
  }
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!props.leaseId)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          class: "mb-10 mt-10",
          type: "info",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace({ path: '/lease-table'})))
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!props.leaseId)
      ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          class: "mb-10 mt-10",
          type: "primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (addHandle()))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })), [
          [_directive_permission, 'Create']
        ])
      : _createCommentVNode("", true),
    (props.leaseId)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 2,
          disabled: detailRows.value.length === 0,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (generateHandle())),
          type: "primary",
          class: "mb-10"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["disabled"]))
      : _createCommentVNode("", true),
    (!props.leaseId)
      ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          key: 3,
          class: "mb-10 mt-10",
          type: "danger",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (delHandle()))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })), [
          [_directive_permission, 'DELETE']
        ])
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      "default-expand-all": "",
      border: "",
      "max-height": _unref(MI_height) + 40 + 'px',
      data: _unref(sortTbData),
      onSelectionChange: handleSelectionChange,
      "row-key": "id"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "55",
          selectable: selectedHandle,
          "reserve-selection": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "类型",
          prop: "feeType",
          formatter: formatFeeType
        }),
        _createVNode(_component_el_table_column, {
          label: "开始时间",
          prop: "startDate",
          width: "110"
        }),
        _createVNode(_component_el_table_column, {
          label: "结束时间",
          prop: "endDate",
          width: "110"
        }),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: _unref(formatNumber),
          label: "押金",
          prop: "depositFee"
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: _unref(formatNumber),
          label: "租金",
          prop: "rentFee"
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: _unref(formatNumber),
          label: "月物管费",
          prop: "pmFee"
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: _unref(formatNumber),
          label: "水电费",
          prop: "utilities"
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: _unref(formatNumber),
          label: "其他费用",
          prop: "otherFee"
        }, null, 8, ["formatter"]),
        (!props.leaseId)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              label: "操作"
            }, {
              default: _withCtx(({ row }) => [
                (!row.children && (row.valid === true || row.remainDay > 0))
                  ? _withDirectives((_openBlock(), _createBlock(_component_el_link, {
                      key: 0,
                      type: "primary",
                      onClick: ($event: any) => (editHandle(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_permission, 'Write']
                    ])
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["max-height", "data"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      class: "mt-10",
      small: "",
      background: "",
      style: {"float":"none"},
      total: _unref(MI_total),
      "page-size": _unref(size),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "onUpdate:page-size": _cache[5] || (_cache[5] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      "page-sizes": [30, 50, 100, 500, 1000],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "page-size", "currentPage", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      title: "创建水电",
      draggable: "",
      modelValue: addFg.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((addFg).value = $event))
    }, {
      default: _withCtx(() => [
        (addFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: addUtilitiesConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "生成账单",
      draggable: "",
      modelValue: addBillFg.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((addBillFg).value = $event))
    }, {
      default: _withCtx(() => [
        (detailRows.value.find(e => e.valid === false) !== undefined)
          ? (_openBlock(), _createBlock(_component_el_alert, {
              key: 0,
              title: "请注意:已选择的明细存在已过期",
              type: "warning",
              closable: false,
              effect: "dark"
            }))
          : _createCommentVNode("", true),
        (addBillFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _mergeProps({
              key: 1,
              ref_key: "generateBillEle",
              ref: generateBillEle
            }, {
          searchConfig: addBillConfig.value,
          submitText: '确定',
          showSubmit: true,
        }), {
              custom: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: upFileFg.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((upFileFg).value = $event)),
      title: "上传凭证"
    }, {
      default: _withCtx(() => [
        (upFileFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _mergeProps({
              key: 0,
              ref: ""
            }, {
          searchConfig: upFileConfig.value,
          submitText: '确定',
          showSubmit: true,
        }, { onSearchFn: generateBillHandle }), {
              custom: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  "on-change": _unref(onChange),
                  "auto-upload": false,
                  action: "",
                  multiple: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, { type: "primary" }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["on-change"])
              ]),
              _: 1
            }, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "编辑",
      draggable: "",
      modelValue: editFg.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((editFg).value = $event))
    }, {
      default: _withCtx(() => [
        (editFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: editConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})